var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('filters',{staticClass:"white-container",attrs:{"inputs":_vm.updatedFilters,"extendButton":false,"extended":true,"filters":_vm.defaultSelected,"loading":_vm.tableLoading || _vm.loader},on:{"filter":_vm.filterContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }